import { mergeClassnames } from '@heathmont/moon-core-tw';
import SiteIcon from '~/client/shared/SiteIcon';
import useSidebarIcon from './hooks/useSidebarIcon';

type Props = {
  icon: string;
  iconExt?: '.svg' | '.png' | '.jpg';
  isHovered: boolean;
  size?: string | number;
};

const SidebarIcon: FC<Props> = ({ icon, isHovered, size, iconExt }) => {
  const { isEmpire, iconSize } = useSidebarIcon();
  return (
    <div
      className={mergeClassnames(
        'flex h-8 w-8 items-center justify-center rounded-full bg-bulma/[.04] [&_img]:duration-200',
        isHovered && '[&_img]:scale-110',
        isEmpire && 'bg-goten',
      )}
      style={{
        width: size,
        height: size,
      }}
    >
      <SiteIcon
        icon={icon.startsWith('http') ? icon : `sidebar_${icon}`}
        width={iconSize}
        height={iconSize}
        ext={iconExt}
      />
    </div>
  );
};

export default SidebarIcon;
